import { render, staticRenderFns } from "./StepFour.vue?vue&type=template&id=7e3227fe"
import script from "./StepFour.vue?vue&type=script&lang=ts"
export * from "./StepFour.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports